module.exports = __webpack_public_path__ + "img/CuCiGlass03.ffd42ea3.png";